import React, {Component} from "react";
const mobx = require('mobx');
const autorun = mobx.autorun;
import UserStore from '../../store/userStore';
import App_data from "../../views/config/App_data";

const defaultAvatar = `${App_data.frontend_url}/img/avatars/defaultProfileImage.jpg`;

let imagesCache = {};

export default class UserAvatar extends Component{

    static defaultProps = {
        classNames: ['sidebar-profile-circle']
    }

    constructor(props) {
        super(props);
        this.state = {
            avatar: defaultAvatar,
            userName: "AnalystPrep",
        }
    }

    componentDidMount() {
        this.dispose = autorun(() => {
            let avatar = UserStore.profileInfo != null && UserStore.profileInfo.imageUrl != null ? UserStore.profileInfo.imageUrl : this.state.avatar;
            const name = UserStore.profileInfo != null && UserStore.profileInfo.username != null ? UserStore.profileInfo.username : this.state.userName;
            const img = new Image();
            img.src = avatar;
            img.onload = () => {
                imagesCache[avatar] = img;
            }
            img.onerror = (e) => {
                console.warn(`Error loading avatar image: ${e.target.src}`);
                avatar = defaultAvatar;
                this.setState({avatar: avatar});
                img.remove();
            }
            this.setState({
                avatar: String(avatar),
                userName: name,
            });
        });
    }

    componentWillUnmount() {
        if (this.dispose) this.dispose();
    }

    render() {
        return  (
            <div className={this.props.classNames.join(' ')} >
                <div className='profile-img' style={{ backgroundImage: `url(${this.state.avatar})` }} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Partial/UserAvatar.js